// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1uUCc","list":"styles_list__1hKcG"};